import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../translation/translation_container';
import toDangerousReactHTML from '../../../../helper/to_dangerous_react_html';
import { generateClassName } from '../../../../../_modules/helper/generate_class_name';
import { featureFlags } from '../../../../../_constants/feature_flags';
import getTranslatedText from '../../../../helper/get_translated_text';
import Translation from '../../../translation/translation';

const { FEATURE_FRIEND_BUY, FEATURE_TYRE_DEALS } = featureFlags;

const lazyCurrentPriceClassNames = generateClassName({
    'product-tile__price-current': true,
    'product-tile__price-current--has-discount': ({ priceRrp }) => !!priceRrp,
});

const lazyCurrentPriceValueClassNames = generateClassName({
    'product-tile__price-current-value': true,
    'has-buy4pay3': ({ hasBuy4Pay3 }) => !!hasBuy4Pay3,
});

export const PricePerPiece = ({ price, priceRrp, hasBuy4Pay3 }) => (
    <div className={lazyCurrentPriceClassNames({ priceRrp })}>
        <TranslationContainer
            translationKey="product-tile-current-price"
            targetProperty="dangerouslySetInnerHTML"
            transform={toDangerousReactHTML}
            placeholder={{ price }}
        >
            <span className={ lazyCurrentPriceValueClassNames({ hasBuy4Pay3 }) } />
        </TranslationContainer>
    </div>
);

PricePerPiece.propTypes = {
    price: PropTypes.string.isRequired,
    priceRrp: PropTypes.string,
    hasBuy4Pay3: PropTypes.bool.isRequired,
};

PricePerPiece.defaultProps = {
  priceRrp: '',
};
